import React from "react";
import { Route, Routes } from "react-router-dom";
import ProcessCostSupportListPage from "../components/_Pages/ProcessCostSupportListPage/ProcessCostSupportListPage";
import DashBoardPage from "../components/_Pages/DashboardPage/DashboardPage";
import DivorceCalculatorPage from "../components/_Pages/DivorceCalculatorPage/DivorceCalculatorPage";
import FineCalculatorPage from "../components/_Pages/FineCalculatorPage/FineCalculatorPage";
import ProcessCostSupportPage from "../components/_Pages/ProcessCostSupportPage/ProcessCostSupportPage";
import ControllingPage from "../components/_Pages/ControllingPage/ControllingPage";
import ActivityOverviewPage from "../components/_Pages/ActivityOverviewPage/ActivityOverviewPage";
import ActivityOverviewPageMobile from "../mobileComponents/_Pages/ActivityOverviewPage/ActivityOverviewPage";
import BoardPage from "../components/_Pages/BoardPage/BoardPage";
import TemplatesPage from "../components/_Pages/TemplatesPage/TemplatesPage";
import CreateCasePage from "../components/_Pages/CreateCasePage/CreateCasePage";
import PaymentRunPage from "../components/_Pages/PaymentRunPage/PaymentRunPage";
import TechBoard from "../components/_Pages/AdminBoard/TechBoard";
import UploadBankPaymentEntriesPage from "../components/_Pages/UploadBankPaymentEntriesPage/UploadBankPaymentEntriesPage";
import BankPaymentEntryPage from "../components/_Pages/BankPaymentEntryPage/BankPaymentEntryPage";
import ExternalInvoicePage from "../components/_Pages/ExternalInvoicePage/ExternalInvoicePage";
import AuthorityInvoicePage from "../components/_Pages/AuthorityInvoicePage/AuthorityInvoicePage";
import PaidTaskCollectionPage from "../components/_Pages/PaidTaskPage/PaidTaskCollectionPage";
import PaidTaskCollectionPageMobile from "../mobileComponents/_Pages/PaidTaskPage/PaidTaskCollectionPage";
import DeadlineOverviewPage from "../components/_Pages/DeadlineOverviewPage/DeadlineOverviewPage";
import DeadlineOverviewPageMobile from "../mobileComponents/_Pages/DeadlineOverviewPage/DeadlineOverviewPage";
import ProductsPage from "../components/_Pages/ProductsPage/ProductsPage";
import MyAccountPage from "../components/_Pages/MyAccountPage/MyAccountPage";
import BonusPage from "../components/_Pages/BonusPage/BonusPage";
import { isMobile } from "react-device-detect";
import Error404Page from "../components/_Pages/Error404Page/Error404Page";
import LayoutDeviceBased from "../routeHelperComponents/LayoutDeviceBased";
import RequireRole from "../components/RequireAuth/RequireRole";
import ScannedMediaObjectListPage from "../components/_Pages/ScannedMediaObjectListPage/ScannedMediaObjectListPage";
import AttachmentMergePage from "../components/_Pages/AttachmentMergePage/AttachmentMergePage.tsx";
import BeaSearchPage from "../components/_Pages/BeaSearchPage/BeaSearchPage";
import AttachmentMergesPage from "../components/_Pages/AttachmentMergesPage/AttachmentMergesPage.tsx";
import CustomerPage from "../components/_Pages/CustomerPage/CustomerPage";
import ExternalApplicationsPage from "../components/_Pages/ExternalApplicationsPage/ExternalApplicationsPage";
import ExternalApplicationPage from "../components/_Pages/ExternalApplicationPage/ExternalApplicationPage";
import HumanResourceManagement from "../components/HumanResourceManagement/HumanResourceManagement";
import MediaObjectsGalleryPage from "../components/_Pages/MediaObjectsGalleryPage/MediaObjectsGalleryPage";
import AttachmentFilterPage from "../components/_Pages/BeaAttachmentFilterPage/AttachmentFilterPage.tsx";
import UserManagementPage from "../components/_Pages/UserManagementPage/UserManagementPage";
import CreateReleaseUpdatePage from "../components/_Pages/CreateReleaseUpdatePage/CreateReleaseUpdatePage";
import ReleaseUpdatesPage from "../components/_Pages/ReleaseUpdatesPage/ReleaseUpdatesPage";
import { Roles } from "../types/BackofficeUser";
import DatasetsPage from "../components/_Pages/DatasetsPage/DatasetsPage";
import StatsPage from "../components/_Pages/StatsPage/StatsPage";
import WireTransferPage from "../components/_Pages/WiretransferPage/WireTransferPage";
import LawyerDashboardPage from "../components/_Pages/LawyerDashboardPage/LawyerDashboardPage";
import CaseRoutes from "./CaseRoutes";
import NotificationsPage from "../components/_Pages/Notifications/NotificationsPage";
import ScanDocumentPage from "../components/_Pages/ScanDocumentPage/ScanDocumentPage";
import AiLab from "../components/_Pages/AiLab/AiLab";
import ClearAndImportEConsult from "../components/_Pages/ClearAndImportEConsult/ClearAndImportEConsult";
import QontoTest from "../components/_Pages/QontoTest/QontoTest";
import QontoOAuthReturn from "../components/_Pages/QontoTest/QontoOAuthReturn";
import BeaStatusPage from "../components/_Pages/BeaStatusPage/BeaStatusPage";
import CommandCenterPage from "../components/_Pages/CommandCenterPage/CommandCenterPage";
import LabelOverviewPage from "../components/_Pages/LabelOverviewPage/LabelOverviewPage";

const ServicesRoutes = () => {
  return (
    <LayoutDeviceBased>
      <Routes>
        <Route path="/" element={isMobile ? <ActivityOverviewPageMobile /> : <ActivityOverviewPage />} />
        <Route path={"/fall/:productUrlPart/:productId/*"} element={<CaseRoutes />} />
        <Route path={"/board/:productUrlPart/:caseType"} element={<BoardPage />} />
        <Route path={"/mandant/:customerId"} element={<CustomerPage />} />
        <Route path={"/board/uebersicht"} element={<ProductsPage />} />
        <Route path={"/aktivitaeten"} element={isMobile ? <ActivityOverviewPageMobile /> : <ActivityOverviewPage />} />
        <Route path={"/dashboard/anwalt"} element={<LawyerDashboardPage />} />
        <Route
          path={"/fristenkalender"}
          element={isMobile ? <DeadlineOverviewPageMobile /> : <DeadlineOverviewPage />}
        />
        <Route
          path={"/ausgeschriebene-aufgaben/verwalten"}
          element={isMobile ? <PaidTaskCollectionPageMobile /> : <PaidTaskCollectionPage />}
        />
        <Route path={"/tools/verfahrenskostenhilfe/antrag/:id"} element={<ProcessCostSupportPage />} />
        <Route path={"/tools"} element={<DashBoardPage />} />
        <Route path={"/tools/labelübersicht"} element={<LabelOverviewPage />} />
        <Route path={"/tools/mandant-anlegen"} element={<CreateCasePage />} />
        <Route path={"/tools/verfahrenskostenhilfe"} element={<ProcessCostSupportListPage />} />
        <Route path={"/tools/hr-planung"} element={<HumanResourceManagement />} />
        <Route path={"/tools/bewerbungen"} element={<ExternalApplicationsPage />} />
        <Route path={"/tools/statistiken"} element={<StatsPage />} />
        <Route path={"/tools/bewerbungen/:applicationId"} element={<ExternalApplicationPage />} />
        <Route path={"/tools/bussgeldrechner"} element={<FineCalculatorPage />} />
        <Route path={"/tools/scheidungskostenrechner"} element={<DivorceCalculatorPage />} />
        <Route
          path={"/tools/vorlagen"}
          element={
            <RequireRole allowedRoles={[Roles.admin, Roles.developer, Roles.productManager]}>
              <TemplatesPage />
            </RequireRole>
          }
        />
        <Route path={"/tools/bea/suche"} element={<BeaSearchPage />} />
        <Route path={"/tools/bea/status"} element={<BeaStatusPage />} />
        <Route path={"/tools/anhangs-filter"} element={<AttachmentFilterPage />} />
        <Route path={"/tools/kommandozentrale"} element={<CommandCenterPage />} />
        <Route path={"/tools/anlagen"} element={<AttachmentMergesPage />} />
        <Route path={"/tools/anlagen/:attachmentMergeId"} element={<AttachmentMergePage />} />
        <Route
          path={"/tools/zahlungen-hochladen"}
          element={
            <RequireRole allowedRoles={[Roles.admin, Roles.banking, Roles.developer]}>
              <UploadBankPaymentEntriesPage />
            </RequireRole>
          }
        />
        <Route
          path={"/tools/zahlungseingaenge-buchen"}
          element={
            <RequireRole allowedRoles={[Roles.admin, Roles.accountmanager, Roles.accounting, Roles.developer]}>
              <BankPaymentEntryPage />
            </RequireRole>
          }
        />
        <Route path={"/tools/zahllauf"} element={<PaymentRunPage />} />
        <Route path={"/tools/controlling"} element={<ControllingPage />} />
        <Route path={"/tools/externe-rechnungen-erstellen"} element={<ExternalInvoicePage />} />
        <Route path={"/tools/bearbeitung-rechnungen-ermittlungsakten"} element={<AuthorityInvoicePage />} />
        <Route path={"/tools/datensaetze"} element={<DatasetsPage />} />
        <Route path={"/tools/tech-board"} element={<TechBoard />} />
        <Route path={"/tools/ueberweisung"} element={<WireTransferPage />} />
        <Route path={"/tools/dokumente-pruefen"} element={<ScannedMediaObjectListPage />} />
        <Route
          path={"/tools/ai-tools"}
          element={
            <RequireRole allowedRoles={[Roles.admin, Roles.developer, Roles.productManager]}>
              <AiLab />
            </RequireRole>
          }
        />
        {import.meta.env.VITE_DEPLOYMENT !== "production" && (
          <>
            <Route
              path={"/tools/ey-kannst-du-mal-eben-die-eakte-entfernen-und-den-import-starten"}
              element={
                <RequireRole allowedRoles={[Roles.admin, Roles.developer, Roles.productManager]}>
                  <ClearAndImportEConsult />
                </RequireRole>
              }
            />
            <Route
              path={"/tools/dokument-scannen"}
              element={
                <RequireRole allowedRoles={[Roles.admin, Roles.developer]}>
                  <ScanDocumentPage />
                </RequireRole>
              }
            />
          </>
        )}
        {import.meta.env.VITE_DEPLOYMENT !== "production" && <Route path={"/tools/ai-tools"} element={<AiLab />} />}
        {import.meta.env.VITE_DEPLOYMENT !== "production" && (
          <>
            <Route path={"/tools/qonto-test-page"} element={<QontoTest />} />
            <Route path={"/tools/qonto-oauth-return"} element={<QontoOAuthReturn />} />
          </>
        )}
        <Route
          path={"/tools/nutzer-verwalten"}
          element={
            <RequireRole allowedRoles={[Roles.admin, Roles.accountmanager, Roles.developer]}>
              <UserManagementPage />
            </RequireRole>
          }
        />
        <Route path={"/mein-konto"} element={<MyAccountPage />} />
        <Route path={"/mein-konto/faelle-und-bonus"} element={<BonusPage />} />
        <Route path={"/notifications"} element={<NotificationsPage />} />
        <Route path={"/tools/gallerie"} element={<MediaObjectsGalleryPage />} />
        <Route
          path={"/tools/release-update/neu"}
          element={
            <RequireRole allowedRoles={[Roles.admin, Roles.developer, Roles.productManager]}>
              <CreateReleaseUpdatePage />
            </RequireRole>
          }
        />
        <Route path={"/tools/release-updates"} element={<ReleaseUpdatesPage />} />
        <Route path={"/*"} element={<Error404Page />} />
      </Routes>
    </LayoutDeviceBased>
  );
};

export default ServicesRoutes;
